import { useEffect } from "react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import OpticksBackground from "../ui/OpticksBackground/OpticksBackground";
import OpticksButton from "../ui/OpticksButton/OpticksButton";
import OpticksLink from "../ui/OpticksLink/OpticksLink";
import * as Sentry from "@sentry/react";
import OpticksMessage from "../ui/OpticksMessage/OpticksMessage";

const ErrorBoundary = () => {
  const error = useRouteError() || "";

  const isRouterErrorString = error
    .toString()
    .includes("TypeError: Failed to fetch dynamically imported module");

  const handleReload = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (error && !(isRouteErrorResponse(error) || isRouterErrorString)) {
      Sentry.captureException(error);
    }
    if (
      isRouterErrorString &&
      sessionStorage.getItem("route-error") !== "true"
    ) {
      sessionStorage.setItem("route-error", JSON.stringify(true));
      handleReload();
    }
  }, [error]);

  if (isRouterErrorString) {
    return (
      <OpticksBackground>
        <OpticksMessage type="warning">
          <b>There&apos;s a temporary problem with the service. </b> <br />
          <p>
            This error may have occurred after a recent deployment. The page
            might be trying to access outdated content. <br />
            Please try reloading the page. If you continue to get this message,
            contact us at{" "}
            <OpticksLink
              href="mailto:support@optickssecurity.com"
              label="support@optickssecurity.com"
            />
          </p>
        </OpticksMessage>

        <OpticksButton
          onClick={handleReload}
          variation="secondary"
          label="Reload Page"
        />
      </OpticksBackground>
    );
  }
  return (
    <OpticksBackground>
      <OpticksMessage type="error">
        <b>
          There&apos;s a temporary problem with the service. Please try again
          later.{" "}
        </b>{" "}
        <br /> If you continue to get this message, contact us.
      </OpticksMessage>
    </OpticksBackground>
  );
};

export default ErrorBoundary;
